import AbstractWidget from '../data/AbstractWidget.js';
import React from 'react';
import ReactDOM from 'react-dom';
import InstantWidgetComponent from './InstantWidgetComponent.jsx';
import PresetService from './PresetService.js';
import WidgetService from './WidgetService.js';

/**
 * 미리보기에 사용되는 클래스
 * toolbox와 update시간 제거됨
 */
class InstantWidget {
	constructor(ctx, store, options) { // isReadOnly=true, elDock, elTarget, cache, theme) {
		this.ctx = ctx;
		this.guid = ctx.guid;

		this.service = WidgetService.get(this.ctx.type);
		this.limit = this.service.constructor.MAX || 1000;

		Object.assign(options, {
			'isReadOnly': true
		});

		this.isReadOnly = options.isReadOnly;
		this.widgetTheme = options.theme;
		this.elDock = options.elDock;
		this.elTarget = options.elTarget;
		this.columns = options.columns;

		this.registerLayout();

		if(!!options.cache) {
			this.endedAt = new Date();
			this.renderContainer(options.cache);
		}
	}


	renderContainer(result) {
		if(!!this.targetElement) {
			ReactDOM.render(
				<InstantWidgetComponent
					isLoading={false}
					isReadOnly={this.isReadOnly}
				/>,
			this.targetElement)
			this._render(result);
		}
	}

	registerLayout() {
		var el;
		if(!!this.elTarget) {
			el = this.elTarget;
		}
		else {
			el = this.elDock.find('.k-d-col[dock-id=' + this.ctx.guid + '] .contentbox')[0];
		}
		this.targetElement = el;
	}

	_render(result) {
		if(!this.rendered) {
			var actualElement = $(this.targetElement).find('.widget-container');

			Object.assign(this.ctx.data, {
				'$$interval': 10000000
			});

			let presetInfo = PresetService.getPresetInfo(),
				presetTheme = presetInfo ? presetInfo.theme: 'white';

			// 각 위젯의 MAX를 제한(미리보기용)
			result = result.slice(0, this.limit);
			this.rendered = this.service.render(actualElement, result, this.ctx.data, Object.assign({theme: this.widgetTheme || presetTheme}, {columnInfo: this.columns}));
			if(typeof this.rendered.dispatchEvent === 'function') {
				var e = new Event('show');
				this.rendered.dispatchEvent(e);
			}

			// 위젯 렌더링 된 후, 차트를 widget-container에 알맞게 resize한다.
			setTimeout(() => {
				if(typeof this.rendered.dispatchEvent === 'function') {
					var e = new Event('resize');

					e.detail = {
						isInstant: true
					}

					this.rendered.dispatchEvent(e);
				}
			});

		}else {
			this.rendered.update(result, this.ctx);
		}
	}

	destroy() {

		if(!!this.rendered) {

			if(typeof this.rendered.dispatchEvent === 'function') {
				var e = new Event('destroy');
				this.rendered.dispatchEvent(e);

				if(!!this.elTarget) {
					$(this.elTarget).empty();
				}
				$(this.targetElement).empty();
			}
			this.rendered = null;
			this.service = null;
		}
	}

}

export default InstantWidget;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/dashboard/InstantWidget.jsx